<template>
  <div>
    <patient-header></patient-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, 0.9); margin-top: 200px">
      <v-container class="site-padding" id="aboutActionSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="institutions-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1
              class="my-header institutions-container--header institutions-container--sections-blue text-uppercase pt-4"
            >
              wyszukiwarka gabinetów
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--institutions"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="my-text institutions-container">
          <v-flex xs12 md6>
            <div class="pb-3">
              <span v-if="isInstitutionsBtnShown()">
                Szanowna Pacjentko, Szanowny Pacjencie, tu możesz sprawdzić, czy
                w&nbsp;Twojej okolicy znajduje się gabinet, do&nbsp;którego
                możesz zapisać się na bezpłatne badania w&nbsp;kierunku jaskry.
                Skorzystaj z mapki, wybierz województwo lub wpisz miejscowość
                w&nbsp;pole wyszukiwarki i&nbsp;znajdź placówkę w&nbsp;Twojej
                okolicy. <br /><br />
              </span>

              <span v-if="!isInstitutionsBtnShown()"
                >Szanowna Pacjentko, Szanowny Pacjencie, zakończyła się&nbsp;IX
                edycja akcji bezpłatnych badań w&nbsp;ramach Światowego Tygodnia
                Jaskry. Dziękujemy Państwu za&nbsp;zainteresowanie naszą
                inicjatywą. Mamy ogromną nadzieję, że&nbsp;z&nbsp;roku na rok do
                akcji Polscy Okuliści Kontra Jaskra włączać się będzie coraz
                więcej gabinetów i&nbsp;przychodni okulistycznych. Robimy
                wszystko, co w naszej mocy, by tak się stało.</span
              ><br /><br />
              <span class="patients-container--sections"
                >Zachęcamy do dbałości o zdrowie oczu nie tylko podczas
                Światowego Tygodnia Jaskry.
              </span>
            </div>

            <v-text-field
              label="Wpisz miejscowość i znajdź placówkę"
              solo
              v-model="search"
              v-on:keypress.enter="Enter"
              placeholder="Wpisz miejscowość i znajdź placówkę"
              v-if="isInstitutionsBtnShown()"
            ></v-text-field>

            <div @click="scrollInstitutions" v-if="isInstitutionsBtnShown()">
              <my-button
                title="Znajdź gabinet"
                text="<span>Znajdź <br>gabinet</span>"
                customClass="patient rect-x1"
              />
            </div>
          </v-flex>

          <v-flex xs12 md5 class="text-xs-left" v-if="isInstitutionsBtnShown()">
            <!-- CSSMap - Poland -->
            <div id="map-poland">
              <ul id="poland" class="poland">
                <li class="pl1" data-state="pl1">
                  <a href="#dolnoslaskie">Dolnośląskie</a>
                </li>
                <li class="pl2" data-state="pl2">
                  <a href="#kujawsko-pomorskie">Kujawsko-pomorskie</a>
                </li>
                <li class="pl3" data-state="pl3">
                  <a href="#lubelskie">Lubelskie</a>
                </li>
                <li class="pl4" data-state="pl4">
                  <a href="#lubuskie">Lubuskie</a>
                </li>
                <li class="pl5" data-state="pl5">
                  <a href="#lodzkie">Łódzkie</a>
                </li>
                <li class="pl6" data-state="pl6">
                  <a href="#malopolskie">Małopolskie</a>
                </li>
                <li class="pl7" data-state="pl7">
                  <a href="#mazowieckie">Mazowieckie</a>
                </li>
                <li class="pl8" data-state="pl8">
                  <a href="#opolskie">Opolskie</a>
                </li>
                <li class="pl9" data-state="pl9">
                  <a href="#podkarpackie">Podkarpackie</a>
                </li>
                <li class="pl10" data-state="pl10">
                  <a href="#podlaskie">Podlaskie</a>
                </li>
                <li class="pl11" data-state="pl11">
                  <a href="#pomorskie">Pomorskie</a>
                </li>
                <li class="pl12" data-state="pl12">
                  <a href="#slaskie">Śląskie</a>
                </li>
                <li class="pl13" data-state="pl13">
                  <a href="#swietokrzyskie">Świętokrzyskie</a>
                </li>
                <li class="pl14" data-state="pl14">
                  <a href="#warminsko-mazurskie">Warmińsko-mazurskie</a>
                </li>
                <li class="pl15" data-state="pl15">
                  <a href="#wielkopolskie">Wielkopolskie</a>
                </li>
                <li class="pl16" data-state="pl16">
                  <a href="#zachodniopomorskie">Zachodniopomorskie</a>
                </li>
              </ul>
            </div>
            <!-- END OF THE CSSMap - Poland -->
          </v-flex>
        </v-layout>

        <!--        <v-layout row wrap class="my-text institutions-container" v-if="!isInstitutionsBtnShown()">-->
        <!--          <v-flex xs12 md8>-->
        <!--            <div class="pb-3">-->
        <!--              <h2-->
        <!--                class="my-header patients-container&#45;&#45;header"-->
        <!--                style="line-height: 1.2; font-size: 28px;"-->
        <!--              > Lista placówek dostępna będzie od 3 marca 2020r. Serdecznie zapraszamy!</h2>-->
        <!--            </div>-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->
      </v-container>

      <v-container
        class="site-padding"
        id="institutions-container"
        v-if="isInstitutionsBtnShown()"
      >
        <div v-if="institutions.length">
          <h1
            class="my-header institutions-container--header institutions-container--sections-blue text-uppercase pt-4"
            v-if="filteredInstitutions.length && !search"
          >
            Lista dostępnych placówek:
          </h1>
          <h1
            class="my-header institutions-container--header institutions-container--sections-blue text-uppercase pt-4"
            v-if="filteredInstitutions.length && search"
          >
            Lista placówek w danej okolicy:
          </h1>
          <div v-if="filtredType === 'search'">
            <v-layout
              v-if="filteredInstitutions.length"
              v-for="institution in filteredInstitutions"
              :key="institution.id"
              row
              wrap
              class="institutions-container"
            >
              <v-flex xs12 class="text-xs-left">
                <div class="sparator-container pt-4">
                  <div class="sparator-rectangle--institutions"></div>
                </div>
                <h1
                  class="institutions-container--header institutions-container--links py-4"
                >
                  {{ institution.name }}
                  <span
                    class="patients-container--sections ml-4"
                    v-if="institution.is_full"
                    >Uwaga: Wszystkie miejsca zarezerwowane!</span
                  >
                </h1>
              </v-flex>
              <v-flex xs12 md5 class="text-xs-left">
                <div class="institutions-container--info-avalibility">
                  <v-avatar :size="50" color="patient">
                    <img
                      src="/static/images/clock.svg"
                      style="height: 60%; border-radius: 0"
                    />
                  </v-avatar>

                  <div class="institutions-container--icons-text">
                    <div class="institutions-container--sections-blue">
                      Godziny otwarcia
                    </div>
                    <div
                      v-for="avalibility in institution.availabilities"
                      :key="avalibility.id"
                    >
                      <span
                        class="institutions-container--sections-blue text-uppercase"
                        >{{ day(avalibility.start_at) }} : &nbsp;</span
                      >
                      <span
                        >{{ hours(avalibility.start_at) }} -
                        {{ hours(avalibility.end_at) }}</span
                      >
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-left">
                <div class="institutions-container--info">
                  <v-avatar :size="50" color="patient">
                    <img
                      src="/static/images/place.svg"
                      style="height: 60%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="institutions-container--icons-text">
                    <div>
                      <span class="institutions-container--sections-blue"
                        >Adres:</span
                      >
                      <span
                        >{{ institution.address }}, {{ institution.post_code }}
                        {{ institution.city }}</span
                      >
                    </div>
                    <div>
                      <span class="institutions-container--sections-blue"
                        >Telefon:</span
                      >
                      <span>{{ institution.phone }}</span>
                    </div>
                    <div v-if="institution.phone2">
                      <span class="institutions-container--sections-blue"
                        >Telefon dodatkowy:</span
                      >
                      <span>{{ institution.phone2 }}</span>
                    </div>
                  </div>
                </div>
              </v-flex>
              <!-- <v-flex
                xs12
                class="mt-3 text-xs-left"
                v-if="institution.declarant.comment"
              >
                <span class="institutions-container--sections-blue"
                  >Uwaga:</span
                >
                <span>{{ institution.declarant.comment }}</span>
              </v-flex> -->
            </v-layout>
            <v-layout
              v-if="!institutions.length || !filteredInstitutions.length"
              align-center
              justify-center
              row
              wrap
              class="institutions-container mx-1"
            >
              <v-flex xs12 class="text-xs-left">
                <h1 class="institutions-container--header pt-4">
                  Niestety we wskazanym miejscu nie został jeszcze zgłoszony
                  żaden gabinet.
                </h1>
                <div class="sparator-container pt-4">
                  <div class="sparator-rectangle--institutions"></div>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="filtredType === 'state'">
            <v-layout
              v-if="filteredByState.length"
              v-for="institution in filteredByState"
              :key="institution.id"
              align-center
              justify-center
              row
              wrap
              class="institutions-container mx-1"
            >
              <v-flex xs12 class="text-xs-left">
                <div class="sparator-container pt-4">
                  <div class="sparator-rectangle--institutions"></div>
                </div>
                <h1
                  class="institutions-container--header institutions-container--links py-4"
                >
                  {{ institution.name }}
                  <span
                    class="patients-container--sections ml-4"
                    v-if="institution.is_full"
                    >Uwaga: Wszystkie miejsca zarezerwowane!</span
                  >
                </h1>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-left">
                <div class="institutions-container--info-avalibility">
                  <v-avatar :size="50" color="patient">
                    <img
                      src="/static/images/clock.svg"
                      style="height: 60%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="institutions-container--icons-text">
                    <div
                      v-for="avalibility in institution.availabilities"
                      :key="avalibility.id"
                    >
                      <span
                        class="institutions-container--sections-blue text-uppercase"
                        >{{ day(avalibility.start_at) }}</span
                      >
                      <span
                        >{{ hours(avalibility.start_at) }} -
                        {{ hours(avalibility.end_at) }}</span
                      >
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-left">
                <div class="institutions-container--info">
                  <v-avatar :size="50" color="patient">
                    <img
                      src="/static/images/place.svg"
                      style="height: 60%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="institutions-container--icons-text">
                    <div>
                      <span class="institutions-container--sections-blue"
                        >Adres:</span
                      >
                      <span
                        >{{ institution.address }}, {{ institution.post_code }}
                        {{ institution.city }}</span
                      >
                    </div>
                    <div>
                      <span class="institutions-container--sections-blue"
                        >Telefon:</span
                      >
                      <span>{{ institution.phone }}</span>
                    </div>
                    <div v-if="institution.phone2">
                      <span class="institutions-container--sections-blue"
                        >Telefon dodatkowy:</span
                      >
                      <span>{{ institution.phone2 }}</span>
                    </div>
                  </div>
                </div>
              </v-flex>
              <!-- <v-flex
                xs12
                class="text-xs-left"
                v-if="institution.declarant.comment"
              >
                <span class="institutions-container--sections-blue"
                  >Uwaga:</span
                >
                <span>{{ institution.declarant.comment }}</span>
              </v-flex> -->
            </v-layout>
            <v-layout
              v-if="!institutions.length || !filteredByState.length"
              align-center
              justify-center
              row
              wrap
              class="institutions-container mx-1"
            >
              <v-flex xs12 class="text-xs-left">
                <h1 class="institutions-container--header pt-4">
                  Niestety we wskazanym miejscu nie został jeszcze zgłoszony
                  żaden gabinet.
                </h1>
                <div class="sparator-container pt-4">
                  <div class="sparator-rectangle--institutions"></div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-container>
    </div>
    <div class="header-separator" style="height: 50px"></div>
  </div>
</template>

<script>
import MyButton from "@/components/partials/Button";
import moment from "moment";
import PatientHeader from "@/components/partials/PatientHeader";
import VueScrollTo from "vue-scrollto";

export default {
  data() {
    return {
      institutions: [],
      search: "",
      state: "",
      filtredType: "search",
      count: 0,
      instituionsAvailable: false,
    };
  },
  components: {
    MyButton,
    PatientHeader,
  },
  mounted() {
    let _this = this;
    const state = {
      pl1: "dolnośląskie",
      pl2: "kujawsko-pomorskie",
      pl3: "lubelskie",
      pl4: "lubuskie",
      pl5: "łódzkie",
      pl6: "małopolskie",
      pl7: "mazowieckie",
      pl8: "opolskie",
      pl9: "podkarpackie",
      pl10: "podlaskie",
      pl11: "pomorskie",
      pl12: "śląskie",
      pl13: "świętokrzyskie",
      pl14: "warmińsko-mazurskie",
      pl15: "wielkopolskie",
      pl16: "zachodniopomorskie",
    };
    $("#map-poland").CSSMap({
      size: 540,
      onClick: function (e) {
        _this.scrollToSection("#institutions-container");
        _this.search = "";
        _this.filtredType = "state";
        _this.state = state[$(e).data("state")];
      },
    });

    window.addEventListener("DOMContentLoaded", () => {
      history.pushState("", "", window.location.pathname);
    });

    window.addEventListener("load", () => {
      let array = Array.from(
        document.getElementById("poland").getElementsByTagName("li")
      );
      array.forEach(function (item) {
        item.classList.remove("active-region");
      });
    });
  },
  computed: {
    filteredInstitutions() {
      let array = Array.from(
        document.getElementById("poland").getElementsByTagName("li")
      );
      array.forEach(function (item) {
        item.classList.remove("active-region");
      });

      return this.institutions.filter((institution) => {
        return institution.city.toLowerCase().match(this.search.toLowerCase());
      });
    },
    filteredByState() {
      return this.institutions.filter((institution) => {
        return institution.state
          .toLowerCase()
          .match("^" + this.state.toLowerCase() + "$");
      });
    },
  },
  watch: {
    search: function () {
      this.filtredType = "search";
    },
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    scrollToSection(section) {
      const options = {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: -200,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true,
      };

      VueScrollTo.scrollTo(section, 300, options);
    },
    Enter(e) {
      this.scrollToSection("#institutions-container");
    },
    day(date) {
      return moment(date).locale("pl").format("dddd");
    },
    hours(date) {
      return moment(date).locale("pl").format("HH:mm");
    },
    fetchData() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/institutions`,
      }).then((result) => {
        this.institutions = result.data;
      });
    },
    isInstitutionsBtnShown() {
      const showDate = "2026-03-03 12:00:00";
      const endDate = "2026-03-14 18:00:00";
      //  const showDate = '2019-12-01 00:00:00';
      if (moment().isAfter(showDate) && moment().isBefore(endDate)) {
        return true;
      }
    },
    scrollInstitutions() {
      if (this.search !== "") {
        this.scrollToSection("#institutions-container");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.institutions-container--relative {
  position: relative;
}
.button-container--absolute {
  position: absolute;
  bottom: 0;
  width: 100%;
  cursor: pointer;
}

.patients-container--sections {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.x1 {
  overflow: hidden;
  width: 250px;
  height: 100px;
  position: relative;
}
.x1 .x2 {
  display: inline-block;
  float: left;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -khtml-border-radius: 50%;
  text-align: center;
  position: relative;
}
.x1-bg {
  background: #9a1c1e;
}
.x2-bg {
  background: #275271;
}
.x1 .x2 span {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 1em;
  height: 1em;
  font-size: 35px;
  overflow: hidden;
  color: #ffffff;
  font-weight: 900;
}
.x1--text {
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 50%;
}
.timer-container--header {
  font-size: 26px;
  color: #9a1c1e;
  text-align: left;
  font-weight: 900;
  font-family: "Fira Sans", sans-serif;
}
.timer-container--wrapper {
  width: 100%;
  margin: 0 auto;
}
.statsCircle {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 0;
  padding: 50% 0;
  border-radius: 50%;

  /* Just making it pretty */
  background: #9a1c1e;
  color: white;
  font-family: Helvetica, Arial Black, sans;
  font-size: 48px;
  text-align: center;
}
.term-container--position {
  align-items: baseline !important;
}
.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}
.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}
.banner {
  background-color: transparent;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: "Fira Sans", sans-serif;
  text-align: left;
  color: #aaa;
  display: block;
  vertical-align: middle;
}
.banner img {
  float: left;
}

.time-container {
  display: inline-flex;
  width: 100%;
}
.time-container--separator {
  width: 145px;
  padding-right: 5px;
}
.institutions-container--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}
.institutions-container--links {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
}
.institutions-container--sections {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.institutions-container--sections-brown {
  color: #a41611;
}
.institutions-container--sections-blue {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
}
.institutions-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.institutions-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: none;
  padding: 5px;
}
.institutions-container--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle--institutions {
  width: 115px;
  height: 8px;
  background-color: #a82824;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.patient-bg {
  position: relative;
}
.patient-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: fixed;
  opacity: 0.1;
  background-image: url("/static/images/bg-main.jpg?v=1");
  background-repeat: repeat;
  background-position: center center;
}
.patient-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
  position: relative;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
}
.button-container--register {
  font-family: "Fira Sans", sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.patient-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px;
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.videoWrapper {
  position: relative;
  width: 95%;
  left: 5%;
  top: 3%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}
.institutions-container--download {
  text-decoration: none;
}
.institutions-container--info {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.institutions-container--info-avalibility {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
}
.institutions-container--icons-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}
@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px;
  }
  .button-container--text {
    font-size: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Institutions.vue